(function () {
  'use strict';

  if (window.DevidCustomerIdentity) return;

  var STORAGE_KEY = 'devid_wishlist_v1';
  var SESSION_IDENTIFIED_KEY = 'devid_wishlist_identified_session';
  var MAX_ITEMS = 40;
  var openerFocus = null;

  function getShell() {
    return document.querySelector('[data-devid-wishlist-shell]');
  }

  function isAuthenticated() {
    var shell = getShell();
    return Boolean(shell && shell.getAttribute('data-customer-state') === 'authenticated');
  }

  function currency() {
    var shell = getShell();
    return shell ? (shell.getAttribute('data-currency') || '') : '';
  }

  function analytics(name, detail) {
    var payload = Object.assign({ event: name }, detail || {});
    if (window.DevidCommerceAnalytics && typeof window.DevidCommerceAnalytics.publish === 'function') {
      if (name === 'wishlist_product_clicked' && typeof window.DevidCommerceAnalytics.rememberAttribution === 'function') {
        window.DevidCommerceAnalytics.rememberAttribution('wishlist', {
          handle: detail && detail.handle ? detail.handle : '',
          destination: detail && detail.destination ? detail.destination : ''
        });
      }
      window.DevidCommerceAnalytics.publish(name, detail || {});
      return;
    }
    window.dispatchEvent(new CustomEvent('devid:wishlist', { detail: payload }));
  }

  function klaviyoTrack(name, item) {
    var properties = {
      ProductID: item.product_id || '',
      VariantID: item.variant_id || '',
      ProductHandle: item.handle || '',
      ProductName: item.title || '',
      Brand: item.vendor || '',
      ProductURL: item.url || '',
      ImageURL: item.image || '',
      PriceCents: Number(item.price || 0),
      Currency: currency()
    };

    try {
      if (window.klaviyo && typeof window.klaviyo.track === 'function') {
        window.klaviyo.track(name, properties);
        return;
      }
      window._learnq = window._learnq || [];
      window._learnq.push(['track', name, properties]);
    } catch (error) {
      // Wishlist must remain usable even if Klaviyo is unavailable.
    }
  }

  function loadItems() {
    try {
      var parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      if (!Array.isArray(parsed)) return [];
      return parsed.filter(function (item) {
        return item && item.handle && item.url;
      }).slice(0, MAX_ITEMS);
    } catch (error) {
      return [];
    }
  }

  function saveItems(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, MAX_ITEMS)));
    } catch (error) {
      // Private browsing/storage restrictions must not break the PDP.
    }
  }

  function itemFromButton(button) {
    return {
      product_id: button.getAttribute('data-product-id') || '',
      variant_id: button.getAttribute('data-variant-id') || '',
      handle: button.getAttribute('data-product-handle') || '',
      title: button.getAttribute('data-product-title') || '',
      vendor: button.getAttribute('data-product-vendor') || '',
      url: button.getAttribute('data-product-url') || '',
      image: button.getAttribute('data-product-image') || '',
      price: Number(button.getAttribute('data-product-price') || 0),
      price_display: button.getAttribute('data-product-price-display') || '',
      added_at: Date.now()
    };
  }

  function itemIndex(items, handle) {
    return items.findIndex(function (item) { return item.handle === handle; });
  }

  function currentCount() {
    return loadItems().length;
  }

  function updateCount(count) {
    document.querySelectorAll('[data-wishlist-count]').forEach(function (node) {
      node.textContent = String(count);
      node.hidden = count < 1;
    });
  }

  function updateButtons(items) {
    document.querySelectorAll('[data-devid-wishlist-button]').forEach(function (button) {
      var handle = button.getAttribute('data-product-handle') || '';
      var saved = itemIndex(items, handle) >= 0;
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      button.classList.toggle('is-saved', saved);
      var label = button.querySelector('[data-wishlist-label]');
      if (label) {
        label.textContent = saved
          ? (button.getAttribute('data-label-saved') || 'Salvato')
          : (button.getAttribute('data-label-save') || 'Salva nei preferiti');
      }
    });
  }

  function safeText(value) {
    return value == null ? '' : String(value);
  }

  function renderItems() {
    var shell = getShell();
    if (!shell) return;
    var items = loadItems();
    var container = shell.querySelector('[data-wishlist-items]');
    var empty = shell.querySelector('[data-wishlist-empty]');
    if (!container || !empty) return;

    container.innerHTML = '';
    empty.hidden = items.length > 0;
    container.hidden = items.length === 0;

    items.forEach(function (item) {
      var article = document.createElement('article');
      article.className = 'devid-wishlist-item';
      article.setAttribute('data-wishlist-item', item.handle);

      var media = document.createElement('a');
      media.className = 'devid-wishlist-item__media';
      media.href = item.url;
      media.setAttribute('data-wishlist-product-link', '');
      media.setAttribute('data-product-handle', item.handle);
      if (item.image) {
        var image = document.createElement('img');
        image.src = item.image;
        image.alt = item.title || '';
        image.loading = 'lazy';
        image.decoding = 'async';
        media.appendChild(image);
      }

      var body = document.createElement('div');
      body.className = 'devid-wishlist-item__body';
      if (item.vendor) {
        var vendor = document.createElement('p');
        vendor.className = 'devid-wishlist-item__vendor';
        vendor.textContent = safeText(item.vendor);
        body.appendChild(vendor);
      }

      var title = document.createElement('a');
      title.className = 'devid-wishlist-item__title';
      title.href = item.url;
      title.textContent = safeText(item.title);
      title.setAttribute('data-wishlist-product-link', '');
      title.setAttribute('data-product-handle', item.handle);
      body.appendChild(title);

      if (item.price_display) {
        var price = document.createElement('p');
        price.className = 'devid-wishlist-item__price';
        price.textContent = safeText(item.price_display);
        body.appendChild(price);
      }

      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'devid-wishlist-item__remove';
      remove.setAttribute('data-wishlist-remove', item.handle);
      remove.setAttribute('aria-label', shell.getAttribute('data-remove-label') || 'Rimuovi dai preferiti');
      remove.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';

      article.appendChild(media);
      article.appendChild(body);
      article.appendChild(remove);
      container.appendChild(article);
    });

    updateCount(items.length);
    updateButtons(items);
  }

  function openDrawer(source) {
    var shell = getShell();
    if (!shell) return;
    openerFocus = document.activeElement;
    shell.hidden = false;
    shell.setAttribute('aria-hidden', 'false');
    document.body.classList.add('devid-wishlist-open');
    renderItems();
    var panel = shell.querySelector('[data-wishlist-panel]');
    if (panel && typeof panel.focus === 'function') panel.focus({ preventScroll: true });
    analytics('wishlist_opened', { source: source || 'unknown', item_count: currentCount() });
  }

  function closeDrawer() {
    var shell = getShell();
    if (!shell) return;
    shell.hidden = true;
    shell.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('devid-wishlist-open');
    if (openerFocus && typeof openerFocus.focus === 'function' && document.contains(openerFocus)) {
      openerFocus.focus({ preventScroll: true });
    }
  }

  function removeItem(handle, source) {
    var items = loadItems();
    var index = itemIndex(items, handle);
    if (index < 0) return;
    var removed = items[index];
    items.splice(index, 1);
    saveItems(items);
    updateCount(items.length);
    updateButtons(items);
    renderItems();
    analytics('wishlist_removed', {
      source: source || 'wishlist_drawer',
      product_id: removed.product_id || '',
      variant_id: removed.variant_id || '',
      handle: removed.handle || '',
      vendor: removed.vendor || '',
      item_count: items.length
    });
    klaviyoTrack('Wishlist Removed', removed);
  }

  function toggleButton(button) {
    var item = itemFromButton(button);
    if (!item.handle) return;
    var items = loadItems();
    var index = itemIndex(items, item.handle);

    if (index >= 0) {
      removeItem(item.handle, 'pdp');
      return;
    }

    items.unshift(item);
    items = items.slice(0, MAX_ITEMS);
    saveItems(items);
    updateCount(items.length);
    updateButtons(items);
    analytics('wishlist_added', {
      source: 'pdp',
      product_id: item.product_id,
      variant_id: item.variant_id,
      handle: item.handle,
      vendor: item.vendor,
      price: item.price,
      item_count: items.length,
      customer_state: isAuthenticated() ? 'authenticated' : 'anonymous'
    });
    klaviyoTrack('Wishlist Added', item);
    openDrawer('wishlist_added');
  }

  function trackAuthenticatedSession() {
    if (!isAuthenticated() || !currentCount()) return;
    try {
      if (window.sessionStorage.getItem(SESSION_IDENTIFIED_KEY) === '1') return;
      window.sessionStorage.setItem(SESSION_IDENTIFIED_KEY, '1');
    } catch (error) {}
    analytics('wishlist_identified', {
      customer_state: 'authenticated',
      item_count: currentCount(),
      persistence: 'browser_local'
    });
  }

  function trapFocus(shell, event) {
    if (!shell || shell.hidden || event.key !== 'Tab') return;
    var panel = shell.querySelector('[data-wishlist-panel]');
    if (!panel) return;
    var focusable = panel.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest ? event.target : null;
    if (!target) return;

    var toggle = target.closest('[data-devid-wishlist-button]');
    if (toggle) {
      event.preventDefault();
      toggleButton(toggle);
      return;
    }

    var opener = target.closest('[data-wishlist-open]');
    if (opener) {
      event.preventDefault();
      openDrawer(opener.getAttribute('data-wishlist-open') || 'pdp');
      return;
    }

    if (target.closest('[data-wishlist-close], [data-wishlist-backdrop]')) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    var remove = target.closest('[data-wishlist-remove]');
    if (remove) {
      event.preventDefault();
      removeItem(remove.getAttribute('data-wishlist-remove') || '', 'wishlist_drawer');
      return;
    }

    var productLink = target.closest('[data-wishlist-product-link]');
    if (productLink) {
      analytics('wishlist_product_clicked', {
        source: 'wishlist_drawer',
        handle: productLink.getAttribute('data-product-handle') || '',
        destination: productLink.getAttribute('href') || '',
        item_count: currentCount()
      });
      return;
    }

    var login = target.closest('[data-wishlist-login]');
    if (login) {
      analytics('wishlist_login_started', {
        source: 'wishlist_drawer',
        item_count: currentCount()
      });
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    var shell = getShell();
    if (!shell || shell.hidden) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeDrawer();
      return;
    }
    trapFocus(shell, event);
  });

  function refresh() {
    var items = loadItems();
    updateCount(items.length);
    updateButtons(items);
    renderItems();
    trackAuthenticatedSession();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();

  document.addEventListener('shopify:section:load', refresh);
  document.documentElement.addEventListener('variant:change', function () {
    window.setTimeout(refresh, 0);
  });

  window.DevidCustomerIdentity = {
    open: openDrawer,
    close: closeDrawer,
    refresh: refresh,
    items: loadItems,
    count: currentCount
  };
})();